import { register } from '@ravnur/core/ui-kit/icon/icon-storage';

register('configurations', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M17,7H7A5,5 0 0,0 2,12A5,5 0 0,0 7,17H17A5,5 0 0,0 22,12A5,5 0 0,0 17,7M17,15A3,3 0 0,1 14,12A3,3 0 0,1 17,9A3,3 0 0,1 20,12A3,3 0 0,1 17,15Z',
    },
  ],
});

register('palette', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M12.022,22a10.017,10.017,0,0,0,9.929-8.632,4.828,4.828,0,0,0-.47-2.895C18.738,5.26,11.019,12.475,11.02,6c0-2.794,0-4-2-4C4,2,2,7.694,2,12A10.011,10.011,0,0,0,12.022,22ZM15.5,12A2.5,2.5,0,1,1,13,14.5,2.5,2.5,0,0,1,15.5,12ZM9,16.5A1.5,1.5,0,1,1,7.5,15,1.5,1.5,0,0,1,9,16.5ZM6.5,6A1.5,1.5,0,1,1,5,7.5,1.5,1.5,0,0,1,6.5,6Zm-1,4.5A1.5,1.5,0,1,1,4,12,1.5,1.5,0,0,1,5.5,10.5Z',
    },
  ],
});

register('minus', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M19,13H5V11H19V13Z',
    },
  ],
});

register('upload-cloud', {
  width: 32,
  height: 32,
  paths: [
    {
      'fill-rule': 'evenodd',
      stroke: 'none',
      'stroke-width': '1',
      d: 'M16,16 L12.75,19.25 L12,18.5 L16.5,14 L21,18.5 L20.25,19.25 L17,16 L17,27 L16,27 L16,16 L16,16 Z M15,21 L8.00281647,21 C5.79793835,21 4,19.209139 4,17 C4,15.1046097 5.32460991,13.5117359 7.10100919,13.1021544 L7.10100919,13.1021544 C7.03467626,12.7448817 7,12.3764904 7,12 C7,8.68629134 9.68629134,6 13,6 C15.6154416,6 17.8400262,7.67345685 18.6614243,10.0080411 C19.435776,9.37781236 20.4237666,9 21.5,9 C23.8583427,9 25.7929639,10.814166 25.9844379,13.1230721 L25.9844379,13.1230721 C27.7144917,13.5630972 29,15.1320162 29,17 C29,19.2046438 27.207878,21 24.9971835,21 L18,21 L18,22 L25.0005601,22 C27.7616745,22 30,19.7558048 30,17 C30,14.9035809 28.7132907,13.1085075 26.8828633,12.3655101 L26.8828633,12.3655101 C26.3600217,9.87224935 24.1486546,8 21.5,8 C20.6371017,8 19.8206159,8.19871575 19.0938083,8.55288165 C17.8911816,6.43144875 15.6127573,5 13,5 C9.13400656,5 6,8.13400656 6,12 C6,12.1381509 6.00400207,12.275367 6.01189661,12.4115388 L6.01189661,12.4115388 C4.23965876,13.1816085 3,14.9491311 3,17 C3,19.7614237 5.23249418,22 7.99943992,22 L15,22 L15,21 L15,21 L15,21 Z',
    },
  ],
});

register('change-owner', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M12 0L11.34 .03L15.15 3.84L16.5 2.5C19.75 4.07 22.09 7.24 22.45 11H23.95C23.44 4.84 18.29 0 12 0M12 4C10.07 4 8.5 5.57 8.5 7.5C8.5 9.43 10.07 11 12 11C13.93 11 15.5 9.43 15.5 7.5C15.5 5.57 13.93 4 12 4M.05 13C.56 19.16 5.71 24 12 24L12.66 23.97L8.85 20.16L7.5 21.5C4.25 19.94 1.91 16.76 1.55 13H.05M12 13C8.13 13 5 14.57 5 16.5V18H19V16.5C19 14.57 15.87 13 12 13Z',
    },
  ],
});

register('dashboard', {
  width: 512,
  height: 512,
  paths: [
    {
      d: 'M336.067,208.92l-40.96,24.747c-14.507,8.533-29.867,16.213-44.373,23.04c-4.267,1.707-9.387,4.267-14.507,6.827 c-17.92,9.387-27.307,29.013-23.04,48.64c3.413,15.36,16.213,28.16,31.573,31.573c3.413,0.853,6.827,0.853,10.24,0.853 c16.213,0,30.72-9.387,38.4-23.893c1.707-4.267,4.267-9.387,6.827-14.507c7.68-14.507,14.507-29.867,23.04-44.373l24.747-40.96 c1.707-3.413,0.853-6.827-1.707-10.24C343.747,207.213,339.48,207.213,336.067,208.92z M308.76,252.44 c-9.387,15.36-17.067,30.72-23.893,46.08c-1.707,5.12-4.267,9.387-6.827,14.507c-5.12,11.093-17.067,16.213-29.013,13.653 c-9.387-1.707-17.067-9.387-18.773-18.773c-2.56-11.947,2.56-23.893,13.653-29.013c4.267-2.56,9.387-4.267,14.507-6.827 c15.36-7.68,31.573-15.36,46.08-23.893l11.093-6.827L308.76,252.44z',
    },
    {
      d: 'M492.719,207.208c-0.108-0.575-0.27-1.146-0.492-1.702c-0.223-0.558-0.507-1.069-0.837-1.537 c-12.787-30.616-31.365-58.265-54.348-81.565c-0.324-0.482-0.701-0.944-1.135-1.378s-0.896-0.811-1.378-1.135 C388.233,74.226,324.764,45.933,255,45.933c-33.418,0-65.389,6.5-94.725,18.281c-0.575,0.108-1.146,0.27-1.701,0.492 c-0.557,0.223-1.069,0.507-1.537,0.837c-30.616,12.787-58.265,31.365-81.565,54.348c-0.482,0.324-0.944,0.701-1.378,1.135 s-0.812,0.896-1.135,1.378C27.293,168.7-1,232.169-1,301.933c0,58.027,18.773,113.493,55.467,158.72 c1.707,2.56,4.267,3.413,6.827,3.413h387.413c2.56,0,5.12-0.853,6.827-3.413C492.227,415.427,511,359.96,511,301.933 C511,268.515,504.5,236.544,492.719,207.208z M445.293,447H65.56c-11.539-14.88-21.122-30.844-28.695-47.616l23.575-9.557 c4.267-1.707,5.973-6.827,4.267-11.093c-1.707-4.267-6.827-5.973-11.093-4.267l-23.11,9.369 c-8.574-23.342-13.394-48.021-14.278-73.369H75.8c5.12,0,8.533-3.413,8.533-8.533S80.92,293.4,75.8,293.4H16.237 c0.957-26.907,6.416-52.715,15.648-76.694L55.32,226.84c0.853,0.853,2.56,0.853,3.413,0.853c3.413,0,5.973-1.707,7.68-5.12 c1.707-4.267,0-9.387-4.267-11.093l-23.672-10.237c10.699-22.831,24.906-43.721,41.922-61.967l17.59,17.59 c1.707,1.707,3.413,2.56,5.973,2.56s4.267-0.853,5.973-2.56c3.413-3.413,3.413-8.533,0-11.947l-17.59-17.59 c19.117-17.828,41.131-32.581,65.244-43.438l9.52,23.482c0.853,3.413,4.267,5.12,7.68,5.12c0.853,0,1.707,0,3.413-0.853 c4.267-1.707,5.973-6.827,4.267-11.093l-9.329-23.012c23.021-8.463,47.679-13.452,73.329-14.364v59.563 c0,5.12,3.413,8.533,8.533,8.533s8.533-3.413,8.533-8.533V63.17c26.907,0.957,52.715,6.416,76.694,15.648l-10.134,23.436 c-1.707,4.267,0,9.387,4.267,11.093c0.853,0.853,2.56,0.853,3.413,0.853c3.413,0,6.827-2.56,7.68-5.12l10.237-23.672 c22.831,10.699,43.721,24.906,61.967,41.922l-17.59,17.59c-3.413,3.413-3.413,8.533,0,11.947c1.707,1.707,3.413,2.56,5.973,2.56 c1.707,0,4.267-0.853,5.973-2.56l17.59-17.59c17.828,19.117,32.581,41.131,43.438,65.244l-23.482,9.52 c-4.267,1.707-5.973,6.827-4.267,11.093c0.853,3.413,4.267,5.12,7.68,5.12c0.853,0,1.707-0.853,3.413-0.853l23.013-9.329 c8.463,23.021,13.452,47.679,14.364,73.329H434.2c-5.12,0-8.533,3.413-8.533,8.533s3.413,8.533,8.533,8.533h59.575 c-0.927,26.593-6.172,52.45-15.418,76.799l-23.677-10.239c-4.267-1.707-9.387,0-11.093,4.267c-1.707,4.267,0,9.387,4.267,11.093 l23.981,10.37C464.644,418.298,455.773,433.121,445.293,447z',
    },
  ],
});

register('upload', {
  width: 16,
  height: 16,
  paths: [
    {
      d: 'M1.5 16C1.1 16 0.75 15.85 0.45 15.55C0.15 15.25 0 14.9 0 14.5V10.925H1.5V14.5H14.5V10.925H16V14.5C16 14.9 15.85 15.25 15.55 15.55C15.25 15.85 14.9 16 14.5 16H1.5ZM7.25 12.175V2.9L4.25 5.9L3.175 4.825L8 0L12.825 4.825L11.75 5.9L8.75 2.9V12.175H7.25Z',
    },
  ],
});

register('logout', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M10.09 15.59L11.5 17l5-5-5-5-1.41 1.41L12.67 11H3v2h9.67l-2.58 2.59zM19 3H5c-1.11 0-2 .9-2 2v4h2V5h14v14H5v-4H3v4c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z',
    },
  ],
});

register('person', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z',
    },
  ],
});

register('home', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M10 19v-5h4v5c0 .55.45 1 1 1h3c.55 0 1-.45 1-1v-7h1.7c.46 0 .68-.57.33-.87L12.67 3.6c-.38-.34-.96-.34-1.34 0l-8.36 7.53c-.34.3-.13.87.33.87H5v7c0 .55.45 1 1 1h3c.55 0 1-.45 1-1z',
    },
  ],
});

register('multi-settings', {
  width: 932.179,
  height: 932.179,
  paths: [
    {
      d: `M61.2,341.538c4.9,16.8,11.7,33,20.3,48.2l-24.5,30.9c-8,10.1-7.1,24.5,1.9,33.6l42.2,42.2c9.1,9.1,23.5,9.899,33.6,1.899
		l30.7-24.3c15.8,9.101,32.6,16.2,50.1,21.2l4.6,39.5c1.5,12.8,12.3,22.4,25.1,22.4h59.7c12.8,0,23.6-9.601,25.1-22.4l4.4-38.1
		c18.8-4.9,36.8-12.2,53.7-21.7l29.7,23.5c10.1,8,24.5,7.1,33.6-1.9l42.2-42.2c9.1-9.1,9.9-23.5,1.9-33.6l-23.1-29.3
		c9.6-16.601,17.1-34.3,22.1-52.8l35.6-4.1c12.801-1.5,22.4-12.3,22.4-25.1v-59.7c0-12.8-9.6-23.6-22.4-25.1l-35.1-4.1
		c-4.801-18.3-12-35.8-21.199-52.2l21.6-27.3c8-10.1,7.1-24.5-1.9-33.6l-42.1-42.1c-9.1-9.1-23.5-9.9-33.6-1.9l-26.5,21
		c-17.2-10.1-35.601-17.8-54.9-23l-4-34.3c-1.5-12.8-12.3-22.4-25.1-22.4h-59.7c-12.8,0-23.6,9.6-25.1,22.4l-4,34.3
		c-19.8,5.3-38.7,13.3-56.3,23.8l-27.5-21.8c-10.1-8-24.5-7.1-33.6,1.9l-42.2,42.2c-9.1,9.1-9.9,23.5-1.9,33.6l23,29.1
		c-9.2,16.6-16.2,34.3-20.8,52.7l-36.8,4.2c-12.8,1.5-22.4,12.3-22.4,25.1v59.7c0,12.8,9.6,23.6,22.4,25.1L61.2,341.538z
		 M277.5,180.038c54.4,0,98.7,44.3,98.7,98.7s-44.3,98.7-98.7,98.7c-54.399,0-98.7-44.3-98.7-98.7S223.1,180.038,277.5,180.038z`,
    },
    {
      d: `M867.699,356.238l-31.5-26.6c-9.699-8.2-24-7.8-33.199,0.9l-17.4,16.3c-14.699-7.1-30.299-12.1-46.4-15l-4.898-24
		c-2.5-12.4-14-21-26.602-20l-41.1,3.5c-12.6,1.1-22.5,11.4-22.9,24.1l-0.799,24.4c-15.801,5.7-30.701,13.5-44.301,23.3
		l-20.799-13.8c-10.602-7-24.701-5-32.9,4.7l-26.6,31.7c-8.201,9.7-7.801,24,0.898,33.2l18.201,19.399
		c-6.301,14.2-10.801,29.101-13.4,44.4l-26,5.3c-12.4,2.5-21,14-20,26.601l3.5,41.1c1.1,12.6,11.4,22.5,24.1,22.9l28.1,0.899
		c5.102,13.4,11.801,26.101,19.9,38l-15.699,23.7c-7,10.6-5,24.7,4.699,32.9l31.5,26.6c9.701,8.2,24,7.8,33.201-0.9l20.6-19.3
		c13.5,6.3,27.699,11,42.299,13.8l5.701,28.2c2.5,12.4,14,21,26.6,20l41.1-3.5c12.6-1.1,22.5-11.399,22.9-24.1l0.9-27.601
		c15-5.3,29.199-12.5,42.299-21.399l22.701,15c10.6,7,24.699,5,32.9-4.7l26.6-31.5c8.199-9.7,7.799-24-0.9-33.2l-18.301-19.399
		c6.701-14.2,11.602-29.2,14.4-44.601l25-5.1c12.4-2.5,21-14,20-26.601l-3.5-41.1c-1.1-12.6-11.4-22.5-24.1-22.9l-25.1-0.8
		c-5.201-14.6-12.201-28.399-20.9-41.2l13.699-20.6C879.4,378.638,877.4,364.438,867.699,356.238z M712.801,593.837
		c-44.4,3.801-83.602-29.3-87.301-73.699c-3.801-44.4,29.301-83.601,73.699-87.301c44.4-3.8,83.602,29.301,87.301,73.7
		C790.301,550.938,757.199,590.138,712.801,593.837z`,
    },
    {
      d: `M205,704.438c-12.6,1.3-22.3,11.899-22.4,24.6l-0.3,25.3c-0.2,12.7,9.2,23.5,21.8,25.101l18.6,2.399
		c3.1,11.301,7.5,22.101,13.2,32.301l-12,14.8c-8,9.899-7.4,24.1,1.5,33.2l17.7,18.1c8.9,9.1,23.1,10.1,33.2,2.3l14.899-11.5
		c10.5,6.2,21.601,11.101,33.2,14.5l2,19.2c1.3,12.6,11.9,22.3,24.6,22.4l25.301,0.3c12.699,0.2,23.5-9.2,25.1-21.8l2.3-18.2
		c12.601-3.101,24.601-7.8,36-14l14,11.3c9.9,8,24.101,7.4,33.201-1.5l18.1-17.7c9.1-8.899,10.1-23.1,2.301-33.2L496.6,818.438
		c6.6-11,11.701-22.7,15.201-35l16.6-1.7c12.6-1.3,22.299-11.9,22.4-24.6l0.299-25.301c0.201-12.699-9.199-23.5-21.799-25.1
		l-16.201-2.1c-3.1-12.2-7.699-24-13.699-35l10.1-12.4c8-9.9,7.4-24.1-1.5-33.2l-17.699-18.1c-8.9-9.101-23.102-10.101-33.201-2.3
		l-12.101,9.3c-11.399-6.9-23.6-12.2-36.399-15.8l-1.601-15.7c-1.3-12.601-11.899-22.3-24.6-22.4l-25.3-0.3
		c-12.7-0.2-23.5,9.2-25.101,21.8l-2,15.601c-13.199,3.399-25.899,8.6-37.699,15.399l-12.5-10.2c-9.9-8-24.101-7.399-33.201,1.5
		l-18.2,17.801c-9.1,8.899-10.1,23.1-2.3,33.199l10.7,13.801c-6.2,11-11.1,22.699-14.3,35L205,704.438z M368.3,675.837
		c36.3,0.4,65.399,30.301,65,66.601c-0.4,36.3-30.301,65.399-66.601,65c-36.3-0.4-65.399-30.3-65-66.601
		C302.1,704.538,332,675.438,368.3,675.837z`,
    },
  ],
});

register('mail', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z',
    },
  ],
});

register('language', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm6.93 6h-2.95c-.32-1.25-.78-2.45-1.38-3.56 1.84.63 3.37 1.91 4.33 3.56zM12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96zM4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2 0 .68.06 1.34.14 2H4.26zm.82 2h2.95c.32 1.25.78 2.45 1.38 3.56-1.84-.63-3.37-1.9-4.33-3.56zm2.95-8H5.08c.96-1.66 2.49-2.93 4.33-3.56C8.81 5.55 8.35 6.75 8.03 8zM12 19.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96zM14.34 14H9.66c-.09-.66-.16-1.32-.16-2 0-.68.07-1.35.16-2h4.68c.09.65.16 1.32.16 2 0 .68-.07 1.34-.16 2zm.25 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95c-.96 1.65-2.49 2.93-4.33 3.56zM16.36 14c.08-.66.14-1.32.14-2 0-.68-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2h-3.38z',
    },
  ],
});

register('help', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z',
    },
  ],
});

register('category', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M12 2l-5.5 9h11z',
    },
    {
      d: 'M3 13.5h8v8H3z',
    },
  ],
  circles: [{ cx: 17.5, cy: 17.5, r: 4.5 }],
});

register('clock', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22C6.47,22 2,17.5 2,12A10,10 0 0,1 12,2M12.5,7V12.25L17,14.92L16.25,16.15L11,13V7H12.5Z',
    },
  ],
});

register('ms-ppt', {
  width: 50,
  height: 50,
  paths: [
    {
      d: 'M 28.875 0 A 1.0001 1.0001 0 0 0 28.8125 0.03125 L 0.8125 5.34375 A 1.0001 1.0001 0 0 0 0 6.34375 L 0 43.65625 A 1.0001 1.0001 0 0 0 0.8125 44.65625 L 28.8125 49.96875 A 1.0001 1.0001 0 0 0 30 49 L 30 44 L 47 44 C 48.093063 44 49 43.093063 49 42 L 49 8 C 49 6.9069372 48.093063 6 47 6 L 30 6 L 30 1 A 1.0001 1.0001 0 0 0 28.875 0 z M 28 2.1875 L 28 6.6875 A 1.001098 1.001098 0 0 0 28 7.28125 L 28 42.8125 A 1.0001 1.0001 0 0 0 28 43.21875 L 28 47.8125 L 2 42.84375 L 2 7.15625 L 28 2.1875 z M 30 8 L 47 8 L 47 42 L 30 42 L 30 37 L 40 37 L 40 35 L 30 35 L 30 29.4375 C 30.923126 29.804917 31.947569 30 33 30 C 37.406438 30 41 26.406438 41 22 L 41 21 L 40 21 L 34 21 L 34 15 L 34 14 L 33 14 C 31.943146 14 30.930371 14.190925 30 14.5625 L 30 8 z M 35 11 L 35 12 L 35 19 L 35 20 L 36 20 L 43 20 L 44 20 L 44 19 C 44 14.593562 40.406438 11 36 11 L 35 11 z M 37 13.1875 C 39.490698 13.617509 41.382491 15.509302 41.8125 18 L 37 18 L 37 13.1875 z M 8.15625 15.65625 L 8.15625 34.375 L 12.375 34.375 L 12.375 27.9375 L 14.375 27.9375 C 16.637 27.9375 18.4595 27.3485 19.8125 26.1875 C 21.1655 25.0265 21.84375 23.503 21.84375 21.625 C 21.84475 17.65 19.466 15.65625 14.75 15.65625 L 8.15625 15.65625 z M 32 16.25 L 32 22 L 32 23 L 33 23 L 38.8125 23 C 38.324363 25.827389 35.971688 28 33 28 C 31.951632 28 30.980018 27.719489 30.125 27.25 A 1.0138205 1.0138205 0 0 0 30 27.1875 L 30 16.8125 A 1.0077822 1.0077822 0 0 0 30.09375 16.75 C 30.661014 16.433728 31.338461 16.368645 32 16.25 z M 12.375 18.90625 L 14.03125 18.90625 C 16.27525 18.90625 17.40625 19.85825 17.40625 21.78125 C 17.40625 23.74625 16.27525 24.71875 14.03125 24.71875 L 12.375 24.71875 L 12.375 18.90625 z',
    },
  ],
});

register('ms-excel', {
  width: 50,
  height: 50,
  paths: [
    {
      d: 'M 28.875 0 A 1.0001 1.0001 0 0 0 28.8125 0.03125 L 0.8125 5.34375 A 1.0001 1.0001 0 0 0 0 6.34375 L 0 43.65625 A 1.0001 1.0001 0 0 0 0.8125 44.65625 L 28.8125 49.96875 A 1.0001 1.0001 0 0 0 30 49 L 30 44 L 47 44 C 48.093063 44 49 43.093063 49 42 L 49 8 C 49 6.9069372 48.093063 6 47 6 L 30 6 L 30 1 A 1.0001 1.0001 0 0 0 28.875 0 z M 28 2.1875 L 28 6.53125 A 1.0043849 1.0043849 0 0 0 28 7.40625 L 28 42.8125 A 1.0001 1.0001 0 0 0 28 43.21875 L 28 47.8125 L 2 42.84375 L 2 7.15625 L 28 2.1875 z M 30 8 L 47 8 L 47 42 L 30 42 L 30 37 L 34 37 L 34 35 L 30 35 L 30 29 L 34 29 L 34 27 L 30 27 L 30 22 L 34 22 L 34 20 L 30 20 L 30 15 L 34 15 L 34 13 L 30 13 L 30 8 z M 36 13 L 36 15 L 44 15 L 44 13 L 36 13 z M 6.6875 15.6875 L 12.15625 25.03125 L 6.1875 34.375 L 11.1875 34.375 L 14.4375 28.34375 C 14.6635 27.76175 14.814 27.31825 14.875 27.03125 L 14.90625 27.03125 C 15.03625 27.63925 15.15925 28.05525 15.28125 28.28125 L 18.53125 34.375 L 23.5 34.375 L 17.75 24.9375 L 23.34375 15.6875 L 18.65625 15.6875 L 15.6875 21.21875 C 15.4005 21.93975 15.19775 22.51 15.09375 22.875 L 15.0625 22.875 C 14.8975 22.266 14.709 21.72425 14.5 21.28125 L 11.8125 15.6875 L 6.6875 15.6875 z M 36 20 L 36 22 L 44 22 L 44 20 L 36 20 z M 36 27 L 36 29 L 44 29 L 44 27 L 36 27 z M 36 35 L 36 37 L 44 37 L 44 35 L 36 35 z',
    },
  ],
});

register('ms-word', {
  width: 50,
  height: 50,
  paths: [
    {
      d: 'M 28.875 0 A 1.0001 1.0001 0 0 0 28.8125 0.03125 L 0.8125 5.34375 A 1.0001 1.0001 0 0 0 0 6.34375 L 0 43.65625 A 1.0001 1.0001 0 0 0 0.8125 44.65625 L 28.8125 49.96875 A 1.0001 1.0001 0 0 0 30 49 L 30 44 L 47 44 C 48.093063 44 49 43.093063 49 42 L 49 8 C 49 6.9069372 48.093063 6 47 6 L 30 6 L 30 1 A 1.0001 1.0001 0 0 0 28.875 0 z M 28 2.1875 L 28 6.6875 A 1.001098 1.001098 0 0 0 28 7.28125 L 28 42.8125 A 1.0001 1.0001 0 0 0 28 43.21875 L 28 47.8125 L 2 42.84375 L 2 7.15625 L 28 2.1875 z M 30 8 L 47 8 L 47 42 L 30 42 L 30 37 L 44 37 L 44 35 L 30 35 L 30 29 L 44 29 L 44 27 L 30 27 L 30 22 L 44 22 L 44 20 L 30 20 L 30 15 L 44 15 L 44 13 L 30 13 L 30 8 z M 4.625 15.65625 L 8.4375 34.34375 L 12.1875 34.34375 L 14.65625 22.375 C 14.77025 21.826 14.8765 21.102 14.9375 20.25 L 14.96875 20.25 C 14.99575 21.023 15.0605 21.749 15.1875 22.375 L 17.59375 34.34375 L 21.21875 34.34375 L 25.0625 15.65625 L 21.75 15.65625 L 19.75 28.125 C 19.634 28.828 19.55825 29.53275 19.53125 30.21875 L 19.5 30.21875 C 19.432 29.34075 19.36825 28.67875 19.28125 28.21875 L 16.90625 15.65625 L 13.40625 15.65625 L 10.78125 28.0625 C 10.61225 28.8545 10.49475 29.581 10.46875 30.25 L 10.40625 30.25 C 10.36625 29.355 10.30675 28.62375 10.21875 28.09375 L 8.1875 15.65625 L 4.625 15.65625 z',
    },
  ],
});

register('pdf', {
  width: 26,
  height: 26,
  paths: [
    {
      d: 'M 7 0 C 4.795 0 3 1.795 3 4 L 3 22 C 3 24.205 4.795 26 7 26 L 19 26 C 21.205 26 23 24.205 23 22 L 23 8 C 23 6.938 22.02725 5.92975 20.28125 4.21875 C 20.03725 3.97875 19.77725 3.71675 19.53125 3.46875 C 19.28325 3.22275 19.02125 2.994 18.78125 2.75 C 17.06925 1.003 16.063 0 15 0 L 7 0 z M 7 2 L 14.28125 2 C 15.00225 2.184 15 3.0505 15 3.9375 L 15 7 C 15 7.551 15.449 8 16 8 L 19 8 C 19.998 8 21 8.005 21 9 L 21 22 C 21 23.104 20.104 24 19 24 L 7 24 C 5.896 24 5 23.104 5 22 L 5 4 C 5 2.896 5.896 2 7 2 z M 12.25 9 C 11.815476 9 11.377131 9.2356404 11.1875 9.59375 C 10.997869 9.9518596 10.980478 10.355803 11.03125 10.78125 C 11.10983 11.439715 11.490044 12.249343 11.875 13.03125 C 11.672481 13.755883 11.564595 14.411449 11.25 15.1875 C 10.863872 16.140009 10.395765 16.893995 9.9375 17.6875 C 9.3357486 17.975472 8.5923976 18.234666 8.15625 18.53125 C 7.6814529 18.854116 7.2924594 19.139147 7.09375 19.5625 C 6.994395 19.774177 6.9641242 20.057908 7.0625 20.3125 C 7.160876 20.567092 7.3689635 20.755298 7.59375 20.875 C 8.0537048 21.119294 8.5680317 20.96798 8.96875 20.6875 C 9.3694683 20.407019 9.7546705 19.982287 10.125 19.46875 C 10.321943 19.195648 10.494457 18.759947 10.6875 18.4375 C 11.285774 18.163333 11.695665 17.867185 12.375 17.625 C 13.321722 17.287491 14.180347 17.164149 15.0625 16.96875 C 15.778659 17.470017 16.524603 17.84375 17.34375 17.84375 C 17.813106 17.84375 18.171092 17.84075 18.5 17.65625 C 18.828908 17.471707 19 17.050417 19 16.71875 C 19 16.453924 18.899882 16.183297 18.71875 16 C 18.537618 15.816703 18.296312 15.688985 18.0625 15.625 C 17.594877 15.49703 17.06988 15.524765 16.4375 15.59375 C 16.114449 15.62899 15.671543 15.805256 15.3125 15.875 C 15.2179 15.80045 15.124901 15.83277 15.03125 15.75 C 14.252645 15.061876 13.539436 14.126992 13 13.1875 C 12.960701 13.119055 12.974771 13.068401 12.9375 13 C 13.071987 12.483329 13.317978 11.884792 13.375 11.4375 C 13.450426 10.845836 13.448615 10.323719 13.3125 9.875 C 13.244442 9.6506405 13.158432 9.417407 12.96875 9.25 C 12.779068 9.082593 12.505584 9 12.25 9 z M 12.125 10 C 12.139462 9.9932461 12.170387 10 12.25 10 C 12.30279 10 12.27224 9.99205 12.28125 10 C 12.29025 10.008 12.3441 10.05439 12.375 10.15625 C 12.4368 10.359965 12.44093 10.764055 12.375 11.28125 C 12.3698 11.32166 12.3498 11.395865 12.34375 11.4375 C 12.26996 11.191907 12.054227 10.848784 12.03125 10.65625 C 11.99424 10.346135 12.05617 10.133469 12.09375 10.0625 C 12.11254 10.027016 12.110538 10.006754 12.125 10 z M 12.5625 14.25 C 13.012793 14.942013 13.537479 15.584777 14.125 16.15625 C 13.412356 16.342541 12.754347 16.429714 12.03125 16.6875 C 11.798571 16.77045 11.664701 16.881047 11.4375 16.96875 C 11.681125 16.468057 11.973645 16.090044 12.1875 15.5625 C 12.37599 15.097529 12.407575 14.709694 12.5625 14.25 z M 17.40625 16.5625 C 17.582088 16.558734 17.717082 16.56764 17.8125 16.59375 C 17.934755 16.62721 17.988975 16.67634 18 16.6875 C 18.01103 16.69866 18 16.6817 18 16.71875 C 18 16.867083 18.02309 16.76829 18 16.78125 C 17.97691 16.79421 17.754394 16.84375 17.34375 16.84375 C 17.18018 16.84375 16.985617 16.635552 16.8125 16.59375 C 17.01373 16.582705 17.230412 16.566266 17.40625 16.5625 z M 9 19.21875 C 8.7909966 19.464119 8.5658853 19.763264 8.40625 19.875 C 8.162816 20.04539 8.1085452 20.024456 8.0625 20 C 8.008222 19.9711 8.033454 19.97046 8.03125 19.96875 C 8.087975 19.87006 8.3290337 19.60876 8.71875 19.34375 C 8.780935 19.30146 8.9313349 19.26201 9 19.21875 z',
    },
  ],
});

register('releases', {
  width: 26,
  height: 26,
  paths: [
    {
      d: 'M23 12l-2.44-2.78.34-3.68-3.61-.82-1.89-3.18L12 3 8.6 1.54 6.71 4.72l-3.61.81.34 3.68L1 12l2.44 2.78-.34 3.69 3.61.82 1.89 3.18L12 21l3.4 1.46 1.89-3.18 3.61-.82-.34-3.68L23 12zm-10 5h-2v-2h2v2zm0-4h-2V7h2v6z',
    },
  ],
});

register('reorder', {
  width: 26,
  height: 26,
  paths: [
    {
      d: 'M14 5h8v2h-8zm0 5.5h8v2h-8zm0 5.5h8v2h-8zM2 11.5C2 15.08 4.92 18 8.5 18H9v2l3-3-3-3v2h-.5C6.02 16 4 13.98 4 11.5S6.02 7 8.5 7H12V5H8.5C4.92 5 2 7.92 2 11.5z',
    },
  ],
});

register('drag', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z',
    },
  ],
});

register('cancel', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z',
    },
  ],
});

register('cancel-bg', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M12 4c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8zm5 11.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z',
      opacity: '.75',
      fill: '#FFF',
    },
    {
      d: 'M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm3.59-13L12 10.59 8.41 7 7 8.41 10.59 12 7 15.59 8.41 17 12 13.41 15.59 17 17 15.59 13.41 12 17 8.41z',
    },
  ],
});

register('assignment', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm2 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z',
    },
  ],
});

register('user', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z',
    },
  ],
});

register('cached', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z',
    },
  ],
});

register('pause', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 14H9V8h2v8zm4 0h-2V8h2v8z',
    },
  ],
});

register('play', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14.5v-9l6 4.5-6 4.5z',
    },
  ],
});

register('build', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M22.7 19l-9.1-9.1c.9-2.3.4-5-1.5-6.9-2-2-5-2.4-7.4-1.3L9 6 6 9 1.6 4.7C.4 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.1c.4.4 1 .4 1.4 0l2.3-2.3c.5-.4.5-1.1.1-1.4z',
    },
  ],
});

register('link', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z',
    },
  ],
});

register('camera', {
  width: 24,
  height: 24,
  circles: [{ cx: 12, cy: 12, r: 3.2 }],
  paths: [
    {
      d: 'M9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z',
    },
  ],
});

register('text-fields', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M9 4v3h5v12h3V7h5V4H9zm-6 8h3v7h3v-7h3V9H3v3z',
    },
  ],
});

register('list', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z',
    },
  ],
});

register('copy', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z',
    },
  ],
});

register('videoplaylist', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M4 10h12v2H4zm0-4h12v2H4zm0 8h8v2H4zm10 0v6l5-3z',
    },
  ],
});

register('audioplaylist', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M15 6H3v2h12V6zm0 4H3v2h12v-2zM3 16h8v-2H3v2zM17 6v8.18c-.31-.11-.65-.18-1-.18-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3V8h3V6h-5z',
    },
  ],
});

register('add-members', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M8 10H5V7H3v3H0v2h3v3h2v-3h3v-2zm10 1c1.66 0 2.99-1.34 2.99-3S19.66 5 18 5c-.32 0-.63.05-.91.14.57.81.9 1.79.9 2.86s-.34 2.04-.9 2.86c.28.09.59.14.91.14zm-5 0c1.66 0 2.99-1.34 2.99-3S14.66 5 13 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm6.62 2.16c.83.73 1.38 1.66 1.38 2.84v2h3v-2c0-1.54-2.37-2.49-4.38-2.84zM13 13c-2 0-6 1-6 3v2h12v-2c0-2-4-3-6-3z',
    },
  ],
});

register('vert-more', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z',
    },
  ],
});

register('widgets', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M13 13v8h8v-8h-8zM3 21h8v-8H3v8zM3 3v8h8V3H3zm13.66-1.31L11 7.34 16.66 13l5.66-5.66-5.66-5.65z',
    },
  ],
});

register('turned-on', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2z',
    },
  ],
});

register('turned-off', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2zm0 15l-5-2.18L7 18V5h10v13z',
    },
  ],
});

register('sitemap', {
  width: 1792,
  height: 1792,
  paths: [
    {
      d: 'M1792 1248v320q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-320q0-40 28-68t68-28h96v-192h-512v192h96q40 0 68 28t28 68v320q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-320q0-40 28-68t68-28h96v-192h-512v192h96q40 0 68 28t28 68v320q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-320q0-40 28-68t68-28h96v-192q0-52 38-90t90-38h512v-192h-96q-40 0-68-28t-28-68v-320q0-40 28-68t68-28h320q40 0 68 28t28 68v320q0 40-28 68t-68 28h-96v192h512q52 0 90 38t38 90v192h96q40 0 68 28t28 68z',
    },
  ],
});

register('template', {
  width: 24,
  height: 24,
  paths: [
    {
      'fill-rule': 'evenodd',
      'clip-rule': 'evenodd',
      d: 'M3 3V9H21V3H3ZM19 5H5V7H19V5Z',
    },
    {
      'fill-rule': 'evenodd',
      'clip-rule': 'evenodd',
      d: 'M3 11V21H11V11H3ZM9 13H5V19H9V13Z',
    },
    {
      d: 'M21 11H13V13H21V11Z',
    },
    {
      d: 'M13 15H21V17H13V15Z',
    },
    {
      d: 'M21 19H13V21H21V19Z',
    },
  ],
});

register('rss', {
  width: 24,
  height: 24,
  circles: [{ cx: 6.18, cy: 17.82, r: 2.18 }],
  paths: [
    {
      d: 'M4 4.44v2.83c7.03 0 12.73 5.7 12.73 12.73h2.83c0-8.59-6.97-15.56-15.56-15.56zm0 5.66v2.83c3.9 0 7.07 3.17 7.07 7.07h2.83c0-5.47-4.43-9.9-9.9-9.9z',
    },
  ],
});

register('launch', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z',
    },
  ],
});

register('event', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M16.53 11.06L15.47 10l-4.88 4.88-2.12-2.12-1.06 1.06L10.59 17l5.94-5.94zM19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11z',
    },
  ],
});

register('clear', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z',
    },
  ],
});

register('checkbox-outline', {
  width: 24,
  height: 24,
  rects: [{ x: 4, y: 4, width: 16, height: 16, style: 'fill: white;' }],
  paths: [
    {
      d: 'M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z',
    },
  ],
});

register('checkbox', {
  width: 24,
  height: 24,
  rects: [{ x: 4, y: 4, width: 16, height: 16, style: 'fill: white;' }],
  paths: [
    {
      d: 'M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z',
    },
  ],
});

register('attachment', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M16.5 6v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5c0 3.04 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5V6h-1.5z',
    },
  ],
});

register('tools', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M21.71 20.29L20.29 21.71A1 1 0 0 1 18.88 21.71L7 9.85A3.81 3.81 0 0 1 6 10A4 4 0 0 1 2.22 4.7L4.76 7.24L5.29 6.71L6.71 5.29L7.24 4.76L4.7 2.22A4 4 0 0 1 10 6A3.81 3.81 0 0 1 9.85 7L21.71 18.88A1 1 0 0 1 21.71 20.29M2.29 18.88A1 1 0 0 0 2.29 20.29L3.71 21.71A1 1 0 0 0 5.12 21.71L10.59 16.25L7.76 13.42M20 2L16 4V6L13.83 8.17L15.83 10.17L18 8H20L22 4Z',
    },
  ],
});

register('zoom', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M15.656,3H8.344C5.397,3,3,5.398,3,8.344v7.312C3,18.603,5.397,21,8.344,21h7.313C18.603,21,21,18.603,21,15.656V8.344	C21,5.398,18.603,3,15.656,3z M14,14.301C14,14.687,13.687,15,13.301,15H9.188C7.98,15,7,14.02,7,12.812V9.699	C7,9.313,7.313,9,7.699,9h4.113C13.02,9,14,9.98,14,11.188V14.301z M17,15l-2-2v-2l2-2V15z',
    },
  ],
});
